import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type { VendorMaterialPricingPlan } from '../types';
import type { UseVendorQuoteRequestParams } from './types';

export const useVendorQuoteRequoteRequest: MutationFunction<
  VendorMaterialPricingPlan,
  UseVendorQuoteRequestParams
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ uuid }) =>
      request(`/vendors/vendor_quote/${uuid}/requote`, {
        init: {
          method: 'POST',
        },
      }),
    ...queryOptions,
  });
};
